import api from '../../lib/api';
import type { ReportType } from './types';

function parseFilenameFromDisposition(header: string | undefined, fallback: string): string {
  if (!header) return fallback;
  const match = /filename="([^"]+)"/i.exec(header);
  return match?.[1]?.slice(0, 255) ?? fallback;
}

/**
 * Descarga un informe PDF on-demand desde GET /api/reports/:type/:id.pdf
 */
export async function downloadReportPdf(type: ReportType, id: string): Promise<void> {
  const boundedId = id.trim().slice(0, 80);
  const resourcePath = boundedId.endsWith('.pdf') ? boundedId : `${boundedId}.pdf`;

  const response = await api.get<Blob>(`reports/${type}/${resourcePath}`, {
    responseType: 'blob',
  });

  const fallback = `${type}-${new Date().toISOString().slice(0, 10)}.pdf`;
  const filename = parseFilenameFromDisposition(
    response.headers['content-disposition'] as string | undefined,
    fallback,
  );

  const url = URL.createObjectURL(response.data);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}
